module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"content":"Content","design":"Design","global":"Global","kind":"Type","netlinking":"Netlinking","technical":"Technical"},"fr":{"content":"Contenu","design":"Design","global":"Global","kind":"Genre","netlinking":"Netlinking","technical":"Technique"},"de":{"content":"Inhalt","design":"Design","global":"Global","kind":"Genre","netlinking":"Netzverlinkung","technical":"Technik"}}')
  delete Component.options._Ctor
}
